import { IGalleryElement } from "./content";
import { IUserScreens } from "./screens";

export interface IToolbar {
  canShare: boolean;
  downloadButtons: IDownloadButton[];
  noteButtons: INoteButton[];
  screensSettings: IScreensSettings | null;
  tools: IZwibblerTools;
}

export class Toolbar implements IToolbar {
  canShare = false;
  downloadButtons = [];
  noteButtons = [];
  screensSettings = null;
  tools = new ZwibblerTools();

  constructor(init?: IToolbar) {
    Object.assign(this, init);
  }
}

export interface IDownloadButton {
  type: "original" | "pdf" | "watermark" | "custom";
  disabled: boolean;
  inProgress: boolean;
}

export interface INoteButton {
  type: "content" | "file";
  hasExistingNote: boolean;
}

export interface IScreensSettings {
  canUseScreens: boolean;
  simplifiedMode: boolean;
  autoOnAirOnActivation: boolean;
  autoOnAirOnSharing: boolean;
  hideFirstScreen: boolean;
  screens: IUserScreens;
}

export type StickyButtonType = "empty" | "share" | "onair";

export interface IToolbarSelectorParams {
  items: IGalleryElement[];
  languageSelectionConfig?: IToolbarLanguageConfig;
  contentConfig?: IToolbarContentConfig;
  isSidebarOpen: boolean;
  stickyButton: StickyButtonType;
}

export interface IToolbarMobileSelectorParams{
  languageSelectionConfig?: IToolbarLanguageConfig;
  contentConfig?: IToolbarContentConfig;
}

export interface IToolbarLanguageConfig {
  changeLanguage: (languageId?: number) => Promise<number>;
}

export interface IToolbarContentConfig {
  contentId: number;
  downloadConfig?: IToolbarDownloadsConfig;
  enableNotes: boolean;
}

export interface IToolbarDownloadsConfig {
  source: "meetings" | "boards";
  sourceId: number; //meetingId or boardId
}

export interface IZwibblerTools {
  pick: boolean;
  laser: boolean;
  arrows: boolean;
  shape: boolean;
  marker: boolean;
  pen: boolean;
  erase: boolean;
  delete: boolean;
  undo: boolean;
  redo: boolean;
  moveFwBack: boolean;
  settings: boolean;
  text: boolean;
  insertImg: boolean;
}

export class ZwibblerTools implements IZwibblerTools {
  pick = false;
  laser = false;
  arrows = false;
  shape = false;
  marker = false;
  pen = false;
  erase = false;
  delete = false;
  undo = false;
  redo = false;
  moveFwBack = false;
  settings = false;
  text = false;
  insertImg = false;

  constructor(init?: IZwibblerTools) {
    Object.assign(this, init);
  }
}
